import axios from 'axios'

const state = () => ({
  items: [],
})

const getters = {
  settings: state => (property = null) => {
    if (!property) {
      return state.items
    }

    const [group, name] = property.split('.')

    if (!name) {
      return state.items.filter(setting => setting.group === group)
    }

    return state.items.find(setting => setting.group === group && setting.name === name)?.payload
  },
  isFieldVisible: (state, getters) => (group, fieldName) => {
    const visibilitySettings = getters.settings(`${group}.field_visibility`);

    if (!visibilitySettings || typeof visibilitySettings !== 'object') {
      return true;
    }

    if (Object.prototype.hasOwnProperty.call(visibilitySettings, fieldName)) {
      return visibilitySettings[fieldName];
    }

    return true;
  }
}

const mutations = {
  SET_SETTINGS (state, settings) {
    state.items = settings
  },
}

const actions = {
  async index ({ commit }, params) {
    try {
      const { data } = await axios.get('/settings', { params })
      commit('SET_SETTINGS', data.data)
    } catch (error) {
      console.log(error)
    }
  },
  async update ({ commit }, body) {
    const { data } = await axios.put('/settings', body)
    commit('SET_SETTINGS', data.data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
